'use strict';

var gridDateFilterUtils = require('./gridDateFilterUtils');

module.exports = function ($state, $serverData, $compile, translate, siteConfig, toast) {
    //Time
    // Class function.
    function TimeFilter() { }
    TimeFilter.prototype.init = function (params) {
        this.$scope = params.$scope || {};
        this.$scope.operationType = 'after';
        this.valueGetter = params.valueGetter;
        this.$scope.onFilterChanged = function () {
            params.filterChangedCallback();
        };
    };

    // mandatory methods
    TimeFilter.prototype.getGui = function () {
        // return '<div style="padding: 4px; width: 200px;height: 200px;"><input ng-model="filterText" type="text" ng-change="onFilterChanged()/></div>'
        return '<div style="padding: 4px; width: 200px;">' +
            '<div style="font-weight: bold;">' + translate.instant('AGGRID.FILTER') + '</div>' +
            '<div><input class="form-control" style="margin: 4px 0px 0px 0px;width: 100%" type="text" ng-model="filterText" placeholder="HH:MM"/></div>' +
            '<div style="margin-top: 4px;"><select class="form-control" style="width: 100%" ng-model="operationType"><option value="after">' + translate.instant('AGGRID.GREATERTHAN') + '</option><option value="before">' + translate.instant('AGGRID.LESSTHAN') + '</option><option value="equal">' + translate.instant('AGGRID.EQUAL') + '</option><option value="between">' + translate.instant('AGGRID.BETWEEN') + '</option></select></div>' +
            '<div><input class="form-control" style="margin: 4px 0px 0px 0px;width: 100%" type="text" ng-model="filterTextEnd" placeholder="HH:MM"/ ng-if="operationType === \'between\'"></div>' +
            '<div><button class="btn" style="margin: 4px 0px 0px 0px; width: 100%" ng-click="onFilterChanged()">' + translate.instant('AGGRID.APPLYFILTER') + '</button></div>' +
            '<div><button class="btn" style="margin: 4px 0px 0px 0px; width: 100%" ng-click="filterText=\'\'; filterTextEnd=\'\'; operationType=\'after\'; onFilterChanged()">' + translate.instant('AGGRID.REMOVEFILTER') + '</button></div>' +
            '</div>';
    };
    TimeFilter.prototype.doesFilterPass = function (params) {
        var filterText = this.$scope.filterText;
        var filterTextEnd = this.$scope.filterTextEnd;
        var passed = true;
        var filterDateEnd;
        if (!filterText) {
            return true;
        }

        if (!this.valueGetter(params)) {
            return false;
        }

        filterText = filterText.split(':');

        var filterDate = new Date();
        filterDate.setFullYear(1, 0, 1);
        filterDate.setHours(parseInt(filterText[0]), parseInt(filterText[1]), 0, 0);

        var rowDate = new Date(this.valueGetter(params)).setFullYear(1, 0, 1);

        if (this.$scope.operationType === 'after') {
            if (filterDate && rowDate && filterDate <= rowDate) {
                passed = true;
            } else {
                passed = false;
            }
        } else if (this.$scope.operationType === 'before') {
            if (filterDate && rowDate && filterDate >= rowDate) {
                passed = true;
            } else {
                passed = false;
            }
        } else if (this.$scope.operationType === 'equal') {
            if (filterDate && rowDate && filterDate == rowDate) {
                passed = true;
            } else {
                passed = false;
            }
        } else if (this.$scope.operationType === 'between') {
            filterTextEnd = filterTextEnd.split(':');
            filterDateEnd = new Date();
            filterDateEnd.setFullYear(1, 0, 1);
            filterDateEnd.setHours(parseInt(filterTextEnd[0]), parseInt(filterTextEnd[1]), 0, 0);

            if (filterDate && rowDate && filterDate <= rowDate && rowDate <= filterDateEnd) {
                passed = true;
            } else {
                passed = false;
            }
        }

        return passed;
    };

    //DATE
    // Class function.
    function DateFilter() { }

    DateFilter.prototype.init = function (params) {
        this.filterParams = params;
        this.$scope = params.$scope;
        this.$scope.operationType = 'after';
        this.valueGetter = params.valueGetter;
        var self = this;
        this.$scope.applyFilter = function () {
            self.applyFilter();
        };
        this.$scope.clearFilter = function () {
            self.clearFilter();
        };
    };

    DateFilter.prototype.isFilterInputValid = function () {
        if (!gridDateFilterUtils.isValidGridDateString(this.$scope.filterText)) {
            return false;
        }
        if (this.$scope.operationType === 'between') {
            return gridDateFilterUtils.isValidGridDateString(this.$scope.filterTextEnd);
        }
        return true;
    };

    DateFilter.prototype.applyFilter = function () {
        if (!this.isFilterInputValid()) {
            if (toast && toast.error) {
                toast.error(translate.instant('DASHBOARD.DATA.ERROR_DATE'));
            }
            return;
        }
        if (this.filterParams && this.filterParams.filterChangedCallback) {
            this.filterParams.filterChangedCallback();
        }
    };

    // silent: true cuando limpia setModel (ag-grid ya dispara onFilterChanged al final de setFilterModel).
    // El botón "Quitar filtro" del popup llama clearFilter() sin silent y sí notifica.
    DateFilter.prototype.clearFilter = function (options) {
        const silent = options && options.silent;
        this.$scope.filterText = '';
        this.$scope.filterTextEnd = '';
        this.$scope.operationType = 'after';
        if (!silent && this.filterParams && this.filterParams.filterChangedCallback) {
            this.filterParams.filterChangedCallback();
        }
    };

    // mandatory methods
    DateFilter.prototype.getGui = function () {
        // return '<div style="padding: 4px; width: 200px;height: 200px;"><input ng-model="filterText" type="text" ng-change="onFilterChanged()/></div>'
        return '<div style="padding: 4px; width: 200px;">' +
            '<div style="font-weight: bold;">' + translate.instant('AGGRID.FILTER') + '</div>' +
            '<div><input class="form-control" style="margin: 4px 0px 0px 0px;width: 100%" type="text" ng-model="filterText" placeholder="YYYY-MM-DD"/></div>' +
            '<div style="margin-top: 4px;"><select class="form-control" style="width: 100%" ng-model="operationType"><option value="after">' + translate.instant('AGGRID.GREATERTHAN') + '</option><option value="before">' + translate.instant('AGGRID.LESSTHAN') + '</option><option value="equal">' + translate.instant('AGGRID.EQUAL') + '</option><option value="between">' + translate.instant('AGGRID.BETWEEN') + '</option></select></div>' +
            '<div><input class="form-control" style="margin: 4px 0px 0px 0px;width: 100%" type="text" ng-model="filterTextEnd" placeholder="YYYY-MM-DD" ng-show="operationType === \'between\'"/></div>' +
            '<div><button class="btn" style="margin: 4px 0px 0px 0px; width: 100%" ng-click="applyFilter()">' + translate.instant('AGGRID.APPLYFILTER') + '</button></div>' +
            '<div><button class="btn" style="margin: 4px 0px 0px 0px; width: 100%" ng-click="clearFilter()">' + translate.instant('AGGRID.REMOVEFILTER') + '</button></div>' +
            '</div>';
    };

    DateFilter.prototype.getApi = function () {
        return this;
    };

    DateFilter.prototype.getModel = function () {
        if (!this.isFilterActive()) {
            return null;
        }
        var filterText = this.$scope.filterText;
        var filterTextEnd = this.$scope.filterTextEnd;
        if (this.$scope.operationType === 'between') {
            return [filterText + 'T00:00:00.000Z', filterTextEnd + 'T23:59:59.999Z'];
        }
        if (this.$scope.operationType === 'equal') {
            return [filterText + 'T00:00:00.000Z', filterText + 'T23:59:59.999Z'];
        }
        if (this.$scope.operationType === 'after') {
            return [filterText + 'T00:00:00.000Z', '2050-12-31T23:59:59.999Z'];
        }
        if (this.$scope.operationType === 'before') {
            return ['1900-01-01T00:00:00.000Z', filterText + 'T23:59:59.999Z'];
        }
        return null;
    };

    DateFilter.prototype.setModel = function (model) {
        if (!model || !Array.isArray(model) || model.length < 2) {
            this.clearFilter({ silent: true });
            return;
        }
        var start = model[0];
        var end = model[1];
        if (!start || !end || String(start).indexOf('undefined') >= 0 || String(end).indexOf('undefined') >= 0) {
            this.clearFilter({ silent: true });
            return;
        }
        if (String(end).indexOf('2050-12-31') === 0) {
            this.$scope.operationType = 'after';
            this.$scope.filterText = gridDateFilterUtils.formatIsoToGridDate(start);
            this.$scope.filterTextEnd = '';
        } else if (String(start).indexOf('1900-01-01') === 0) {
            this.$scope.operationType = 'before';
            this.$scope.filterText = gridDateFilterUtils.formatIsoToGridDate(end);
            this.$scope.filterTextEnd = '';
        } else if (String(start).substring(0, 10) === String(end).substring(0, 10)) {
            this.$scope.operationType = 'equal';
            this.$scope.filterText = gridDateFilterUtils.formatIsoToGridDate(start);
            this.$scope.filterTextEnd = '';
        } else {
            this.$scope.operationType = 'between';
            this.$scope.filterText = gridDateFilterUtils.formatIsoToGridDate(start);
            this.$scope.filterTextEnd = gridDateFilterUtils.formatIsoToGridDate(end);
        }
        if (!this.isFilterInputValid()) {
            this.clearFilter({ silent: true });
        }
    };

    DateFilter.prototype.isFilterActive = function () {
        return this.isFilterInputValid();
    };

    DateFilter.prototype.doesFilterPass = function (params) {
        if (!this.isFilterActive()) {
            return true;
        }
        var rowCalendar = gridDateFilterUtils.toGridCalendarDateString(this.valueGetter(params));
        if (!rowCalendar) {
            return false;
        }
        var from = String(this.$scope.filterText).trim();
        var op = this.$scope.operationType;
        if (op === 'after') {
            return rowCalendar >= from;
        }
        if (op === 'before') {
            return rowCalendar <= from;
        }
        if (op === 'equal') {
            return rowCalendar === from;
        }
        if (op === 'between') {
            var to = String(this.$scope.filterTextEnd).trim();
            return rowCalendar >= from && rowCalendar <= to;
        }
        return true;
    };

    /**
     * ag-grid 3 intercepta la rueda en columnas fijadas y solo hace scroll vertical.
     * Con Shift + rueda, desplaza el cuerpo horizontalmente desde fase capture (antes que ag-grid).
     */
    function bindShiftWheelHorizontalScroll(hostElement) {
        if (!hostElement || !hostElement.addEventListener) {
            return;
        }
        var wheelHandler = function (e) {
            if (!e.shiftKey) {
                return;
            }
            var bodyViewport = hostElement.querySelector('.ag-body-viewport');
            if (!bodyViewport) {
                return;
            }
            if (bodyViewport.scrollWidth <= bodyViewport.clientWidth + 1) {
                return;
            }
            var delta = 0;
            if (e.type === 'wheel') {
                delta = (e.deltaX !== 0 ? e.deltaX : e.deltaY);
                if (e.deltaMode === 1) {
                    delta *= 16;
                } else if (e.deltaMode === 2) {
                    delta *= bodyViewport.clientHeight;
                }
            } else if (e.type === 'mousewheel') {
                /* legacy: wheelDelta suele ser múltiplo de 120 */
                delta = -e.wheelDelta / 3;
            } else if (e.type === 'DOMMouseScroll') {
                delta = e.detail * 20;
            }
            if (!delta) {
                return;
            }
            bodyViewport.scrollLeft += delta;
            e.preventDefault();
            e.stopImmediatePropagation();
        };
        hostElement.addEventListener('wheel', wheelHandler, { capture: true, passive: false });
        hostElement.addEventListener('mousewheel', wheelHandler, { capture: true, passive: false });
        hostElement.addEventListener('DOMMouseScroll', wheelHandler, { capture: true, passive: false });
    }

    /**
     * Con una columna pineada a la derecha, ag-grid 3 dibuja el scroll vertical
     * dentro de esa columna y no lo reserva en el header. Iguala ambos anchos.
     */
    function bindPinnedRightScrollbarSync(hostElement, gridApi) {
        if (!hostElement) {
            return;
        }
        var sync = function () {
            var pinnedViewport = hostElement.querySelector('.ag-pinned-right-cols-viewport');
            var pinnedHeader = hostElement.querySelector('.ag-pinned-right-header');
            var pinnedContainer = hostElement.querySelector('.ag-pinned-right-cols-container');
            var headerViewport = hostElement.querySelector('.ag-header-viewport');
            var bodyWrapper = hostElement.querySelector('.ag-body-viewport-wrapper');
            if (!pinnedViewport || !pinnedHeader || !pinnedContainer || !pinnedContainer.offsetWidth) {
                return;
            }
            var scrollbarWidth = Math.max(0, pinnedViewport.offsetWidth - pinnedViewport.clientWidth);
            var totalWidthPx = (pinnedContainer.offsetWidth + scrollbarWidth) + 'px';
            if (pinnedViewport.style.width !== totalWidthPx) {
                pinnedViewport.style.width = totalWidthPx;
            }
            pinnedHeader.style.width = totalWidthPx;
            if (headerViewport) {
                headerViewport.style.marginRight = totalWidthPx;
            }
            if (bodyWrapper) {
                bodyWrapper.style.marginRight = totalWidthPx;
            }
        };
        var schedule = function () {
            setTimeout(sync, 0);
        };
        schedule();
        if (gridApi && gridApi.addEventListener) {
            gridApi.addEventListener('modelUpdated', schedule);
            gridApi.addEventListener('gridSizeChanged', schedule);
            gridApi.addEventListener('columnResized', schedule);
        }
    }

    const URL_IN_TEXT_REGEX = /https?:\/\/[^\s<>"']+/gi;

    function escapeHtml(str) {
        return String(str)
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;');
    }

    function cellValueToDisplayString(value) {
        if (value == null || value === '') {
            return '';
        }
        if (typeof value === 'string') {
            return value;
        }
        if (typeof value === 'number' || typeof value === 'boolean') {
            return String(value);
        }
        if (Array.isArray(value)) {
            return value.map(function (item) {
                if (item == null) {
                    return '';
                }
                if (typeof item === 'object') {
                    try {
                        return JSON.stringify(item);
                    } catch (e) {
                        return String(item);
                    }
                }
                return String(item);
            }).join(', ');
        }
        if (typeof value === 'object') {
            try {
                return JSON.stringify(value);
            } catch (e) {
                return String(value);
            }
        }
        return String(value);
    }

    function linkifyUrlsInText(text) {
        if (!text) {
            return '';
        }
        let result = '';
        let lastIndex = 0;
        URL_IN_TEXT_REGEX.lastIndex = 0;
        let match;
        while ((match = URL_IN_TEXT_REGEX.exec(text)) !== null) {
            result += escapeHtml(text.slice(lastIndex, match.index));
            let url = match[0];
            const trailingMatch = url.match(/[.,;:!?)\]}]+$/);
            let trailing = '';
            if (trailingMatch) {
                trailing = trailingMatch[0];
                url = url.slice(0, -trailing.length);
            }
            if (url) {
                result += '<a target="_blank" rel="noopener noreferrer" href="' + escapeHtml(url) + '">' +
                    escapeHtml(url) + '</a>';
            }
            result += escapeHtml(trailing);
            lastIndex = match.index + match[0].length;
        }
        result += escapeHtml(text.slice(lastIndex));
        return result;
    }

    function formatGraphDateCell(value, cutToDateOnly) {
        if (value == null || value === '') {
            return '';
        }
        var s = String(value).trim();
        if (/^\d{4}-\d{2}-\d{2}$/.test(s)) {
            return s;
        }
        var date = new Date(s);
        if (isNaN(date.getTime())) {
            return s;
        }
        if (cutToDateOnly) {
            return date.toLocaleDateString('en-CA', {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit'
            }).replace(/\//g, '-');
        }
        if (typeof date.getYYYYMMddHHmmss === 'function') {
            return date.getYYYYMMddHHmmss();
        }
        return s;
    }

    return {
        selectAllRenderer: function (params) {
            var toReturn = '<span ng-click="ctrl.selectAll(ctrl.selectAllStatus)" class="select-header-span"><input type="checkbox" ng-model="ctrl.selectAllStatus" class="ag-selection-checkbox select-header-checkbox"></span>';
            var eDiv = document.createElement('div');
            eDiv.innerHTML = toReturn;
            $compile(eDiv)(params.$scope);
            return eDiv;
        },
        geoRenderer: function (params) {
            params.value = JSON.parse(params.value);
            if (params.value && params.value.coords) {
                return '<div class="grid--renderer--icon-data"><div class="grid--renderer--icon-data--icon"><i class="icon ion-android-pin" ></i></div><span class="grid--renderer--icon-data--label"><a target="_blank" href="https://www.google.com.ar/maps/search/' + params.value.coords.latitude + ', ' + params.value.coords.longitude + '">' + params.value.coords.latitude.toFixed(4) + ', ' + params.value.coords.longitude.toFixed(4) + '</a></span></div>';
            }
            return;
        },
        dateRenderer: function (params) {
            if (!params.value) {
                return '';
            }
            var cutToDateOnly = !(params.colDef && params.colDef.showDateTime);
            if (params.colDef && params.colDef.formData && params.colDef.formData.localeAndCutDate) {
                cutToDateOnly = true;
            }
            return formatGraphDateCell(params.value, cutToDateOnly);
        },
        timeRenderer: function (params) {
            if (params.value) {
                var date = new Date(params.value);
                return date.toLocaleTimeString();
            }
            return;
        },
        timestampRenderer: function (params) {
            if (!params.value) {
                return;
            }
            var cutToDateOnly = !!(params.colDef && params.colDef.formData && params.colDef.formData.localeAndCutDate);
            return formatGraphDateCell(params.value, cutToDateOnly);
        },
        checkboxRenderer: function (params) {
            if (params.value) {
                return '<span style="margin: auto" class="grid--renderer--icon-data--icon icon ion-android-done " aria-hidden="true"></span>';
            }
        },
        signRenderer: function (params) {
            if (params.value) {
                return '<a target="_blank" href="' + params.value + '"><img class="grid--renderer--sign" src="' + params.value + '"/></a>';
            }
            return;
        },
        imgRenderer: function (params) {
            if (params.value && !Array.isArray(params.value))
                params.value = [params.value]
            if (params.value) {
                return params.value.map(url => '<a target="_blank" href="' + url + '"><img class="grid--renderer--sign" src="' + url + '"/></a>').join(" ");
            }
            return;
        },
        linkRenderer: function (params) {
            if (params.value && params.value != "" && !Array.isArray(params.value))
                params.value = [params.value]
            if (params.value) {
                return params.value.map(url => '<a target="_blank" href=" style="display: flex; justify-content: center;"' + url + '"><img style="height: 14px;" src="https://field.voolks.com/app/images/icons/' + params.colDef.fieldType + '.png">' + url.substr(url.lastIndexOf("-")) + '</a>').join(" ");
            }
            return;
        },
        textWithLinksRenderer: function (params) {
            const text = cellValueToDisplayString(params.value);
            if (!text) {
                return '';
            }
            return linkifyUrlsInText(text);
        },
        galleryRenderer: function (params) {
            params.value = JSON.parse(params.value);
            if (params.value) {
                return '<grid-photos data="data" field="\'' + params.colDef.field + '\'" type="\'' + params.colDef.fieldType + '\'"></grid-photos>';
            }
            return;
        },
        profileRender: function (params) {
            if (params.value) {
                return '<div class="grid--renderer--user"><div style="background-image: url(\'' + params.value + '\')" class="grid--renderer--user--image"></div></div>';
            }
            return '<div class="grid--renderer--user"><div class="grid--renderer--user--image"></div></div>';
        },
        validatorRenderer: function (params) {
            if (params.value) {
                return '<div class="grid--renderer--user"><span class="grid--renderer--user--name">' + params.value + '</span></div>'
            }
            return '<div class="grid--renderer--user"><span class="grid--renderer--user--name"></span></div>';
        },
        userRenderer: function (params) {
            if (params.value) {
                if (params.data.member && params.data.member.profileUrl) {
                    return '<div class="grid--renderer--user"><div style="background-image: url(\'' + params.data.member.profileUrl + '\')" class="grid--renderer--user--image"></div><span class="grid--renderer--user--name">' + params.value + '</span></div>';
                }
            }
            return '<div class="grid--renderer--user"><div class="grid--renderer--user--image"></div><span class="grid--renderer--user--name">' + params.value + '</span></div>';
        },
        photosRenderer: function (params) {
            params.value = JSON.parse(params.value);
            if (params.value) {
                return '<grid-photos data="data" field="\'' + params.colDef.field + '\'"></grid-photos>';
            }
            return;
        },
        docsRenderer: function (params) {
            return '<grid-docs data="data" field="\'' + params.colDef.field + '\'"></grid-docs>';
        },
        simpleListRenderer: function (params) {
            // console.log('params', params)
            // console.log('params.colDef', params.colDef)
            params.$scope.colDef = params.colDef;
            params.value = JSON.parse(params.value);
            if (params.value && params.value.length) {
                return "<simple-list-viz data='data' field='" +
                    JSON.stringify(params.colDef) +
                    "'></simple-list-viz>";
            }
            return;
        },
        pdfRenderer: function (params) {
            return '<pdf item="data"></pdf>';
        },
        // ACA
        HTMLRenderer: function (params) {
            params.$scope.$state = $state;

            let serverUrl = siteConfig.serverUrl ? siteConfig.serverUrl : $serverData.server;
            // console.log('HTMLRenderer params', params, siteConfig.serverUrl, $state.params.departmentId, params.data.formId, params.data.id);
            return '<a target="_blank" href="' + serverUrl + '/departments/{{$state.params.departmentId}}/forms/{{data.formId}}/html/{{data.id}}">HTML</a>';
        },
        linkReportHTMLRenderer: function (params) {           
            if (params.value == null || params.value === '')
                return '';
            params.$scope.$state = $state;
            // return '<a target="_blank" href="'+ $serverData.server + '/departments/{{$state.params.departmentId}}/forms/0/html/' + params.value + '"><img style="height: 14px;" src="https://field.voolks.com/app/images/icons/textarea.png">'  + '</a>';
            let serverUrl = siteConfig.serverUrl ? siteConfig.serverUrl : $serverData.server;
            // console.log('linkReportHTMLRenderer params', params, siteConfig.serverUrl, $state.params.departmentId);
            return '<a target="_blank" href="' + serverUrl + '/departments/{{$state.params.departmentId}}/forms/0/html/' + params.value + '"><i class="glyphicon glyphicon-list-alt" style="color: blue; cursor: pointer;"></i>' + '</a>';
        },
        linkLockedByRenderer: function (params) {
            params.$scope.$state = $state;
            var serverUrl = siteConfig.serverUrl ? siteConfig.serverUrl : $serverData.server;
            var raw = params.value != null ? String(params.value) : "";
            var pipe = raw.indexOf("|");
            var label = pipe >= 0 ? raw.slice(0, pipe) : raw;
            var targetId = pipe >= 0 ? raw.slice(pipe + 1) : "";
            if (!targetId && label) {
                targetId = label;
                label = "";
            }
            // Si el DS es de tipo "query" busco el formId en la colDef, sino uso 0
            var colFormId = params.colDef && params.colDef.lockedByHtmlFormId;
            var formId = colFormId != null && colFormId !== "" ? colFormId : 0;
            if (!targetId) {
                return label ? "<span>" + label.replace(/&/g, "&amp;").replace(/</g, "&lt;") + "</span>" : "";
            }
            var encId = encodeURIComponent(targetId);
            var href = serverUrl + "/departments/{{$state.params.departmentId}}/forms/" + formId + "/html/" + encId;
            var safeLabel = (label || targetId).replace(/&/g, "&amp;").replace(/</g, "&lt;");
            return '<a target="_blank" href="' + href + '"><span>' + safeLabel + '</span> <i class="glyphicon glyphicon-list-alt" style="color: blue; cursor: pointer;"></i></a>';
        },
        validateRenderer: function (params) {
            // console.log('ACA 1', params);
            var spec = params.colDef.validateSpec || {};
            let validate = `<validate 
                                item="data"
                                pages='${JSON.stringify(spec.pages || [])}'
                                type="'${spec.type || 'distinct'}'"
                                instances='${spec.instances || 1}'
                                users='${JSON.stringify(spec.users || [])}'
                                current-user-team-leader='${!!spec.currentUserTeamLeader}'
                                validate-defined='${JSON.stringify(spec.validate_defined || [])}'
                                allow-cancel='${!!spec.allowCancel}' 
                                allow-cancel-options='${JSON.stringify(spec.allowCancelOptions || [])}'
                                allow-reject-options='${JSON.stringify(spec.allowRejectOptions || [])}'>
                            </validate>`;
            // console.log('validate', validate);
            return validate;
        },

        payloadGetter: function (params) {
            if (params.data.payload[params.colDef.field] && params.data.payload[params.colDef.field].value) {
                return params.data.payload[params.colDef.field].value;
            }
            return null;
        },
        signGetter: function (params) {
            if (params.data.payload[params.colDef.field] && params.data.payload[params.colDef.field].value) {
                return params.data.payload[params.colDef.field].value;
            }
            return null;
        },
        photosGetter: function (params) {
            if (params.data.payload[params.colDef.field] && params.data.payload[params.colDef.field].value) {
                return JSON.stringify(params.data.payload[params.colDef.field].value);
            }
            return JSON.stringify(null);
        },
        simpleListGetter: function (params) {
            if (params.data.payload[params.colDef.field] && params.data.payload[params.colDef.field].value) {
                var records = params.data.payload[params.colDef.field].value.reduce(function (recordArray, item, index, orig) {
                    recordArray.push([]);
                    params.colDef.formData.nodes.forEach(function (node) {
                        var value = '';
                        if (item[node.id] && item[node.id].value) {
                            value = item[node.id].value;
                            if (item[node.id].type == 'select' || item[node.id].type == 'multiple') {
                                var stripOptionLabel = function (raw) {
                                    if (raw == null || raw === '') {
                                        return '';
                                    }
                                    var s = String(raw);
                                    var idx = s.indexOf("|");
                                    return idx >= 0 ? s.substring(idx + 1) : s;
                                };
                                if (Array.isArray(item[node.id].value)) {
                                    value = item[node.id].value.map(stripOptionLabel).join(',');
                                } else {
                                    value = stripOptionLabel(item[node.id].value);
                                }
                            }else if(item[node.id].type == 'timestamp'){
                                value = (new Date(item[node.id].value)).toLocaleString("af");
                            }else if(item[node.id].type == 'date'){
                                value = (new Date(item[node.id].value)).toLocaleDateString("af");
                            }else if(item[node.id].type == 'time'){
                                value = (new Date(item[node.id].value)).toLocaleTimeString("af");
                            }
                        }
                        var temp = (node.name || node.label) + ': ' + (value);
                        recordArray[index].push(temp);
                    });

                    return recordArray;
                }, []);

                // return JSON.stringify(params.data.payload[params.colDef.field].value);
                // console.log('simpleListGetter records', records)
                return JSON.stringify(records);

            }
            return JSON.stringify(null);
        },
        geoGetter: function (params) {
            if (params.data.payload[params.colDef.field] && params.data.payload[params.colDef.field].value) {
                return JSON.stringify(params.data.payload[params.colDef.field].value);
            }
            return JSON.stringify(null);
        },
        numberRenderer: function (params) {
            if (params.value === null || params.value === undefined) {
                return '';
            }

            let formattedValue = params.value;
            const field = params.colDef.formData;

            // autonumeric puede tener formato alfanumérico (ej: "2026-001") - mostrarlo tal cual
            if (field && field.type === 'autonumeric' && params.value != null) {
                const strVal = String(params.value);
                if (!/^-?\d+(\.\d+)?$/.test(strVal.trim())) {
                    return strVal;
                }
            }

            if (field && field.templateData) {
                let numericValue = parseFloat(params.value);
                if (isNaN(numericValue)) {
                    return formattedValue;
                }
                if (field.templateData.forceDecimals && typeof field.templateData.maxDecimalsCount === 'number') {
                    formattedValue = numericValue.toFixed(field.templateData.maxDecimalsCount);
                    numericValue = parseFloat(formattedValue);
                } else {
                    formattedValue = numericValue;
                }
                if (field.templateData.thousandSeparator) {
                    formattedValue = new Intl.NumberFormat('en-US', {
                        minimumFractionDigits: field.templateData.forceDecimals && typeof field.templateData.maxDecimalsCount === 'number' ? field.templateData.maxDecimalsCount : 0,
                        maximumFractionDigits: field.templateData.forceDecimals && typeof field.templateData.maxDecimalsCount === 'number' ? field.templateData.maxDecimalsCount : 20
                    }).format(numericValue);
                }
            }
            return formattedValue;
        },
        formulaGetter: function (params) {
            if (params.data.payload[params.colDef.field] === undefined || params.data.payload[params.colDef.field].value === undefined) {
                return '';
            }

            let rawValue = params.data.payload[params.colDef.field].value;
            if (rawValue == null)
                return "";
            let formattedValue = rawValue;
            const field = params.colDef.formData;

            if (field && field.templateData && !field.templateData.isAdvanced) {
                let numericValue = parseFloat(rawValue);
                if (isNaN(numericValue)) {
                    return formattedValue;
                }
                if (field.templateData.forceDecimals && typeof field.templateData.formula?.decimals === 'number') {
                    formattedValue = numericValue.toFixed(field.templateData.formula.decimals);
                    numericValue = parseFloat(formattedValue);
                } else {
                    formattedValue = numericValue;
                }
                if (field.templateData.thousandSeparator) {
                    formattedValue = new Intl.NumberFormat('en-US', {
                        minimumFractionDigits: field.templateData.forceDecimals && typeof field.templateData.formula?.decimals === 'number' ? field.templateData.formula.decimals : 0,
                        maximumFractionDigits: field.templateData.forceDecimals && typeof field.templateData.formula?.decimals === 'number' ? field.templateData.formula.decimals : 20
                    }).format(numericValue);
                }
            }
            return formattedValue?.toString();
        },
        numberGraphRenderer: function (params) {
            if (params.value === null || params.value === undefined) {
                return '';
            }

            let formattedValue = params.value;
            const field = params.colDef.formData;

            // autonumeric puede tener formato alfanumérico (ej: "2026-001") - mostrarlo tal cual
            if (field && field.type === 'autonumeric' && params.value != null) {
                const strVal = String(params.value);
                if (!/^-?\d+(\.\d+)?$/.test(strVal.trim())) {
                    return strVal;
                }
            }

            if (field && field.templateData) {
                let numericValue = parseFloat(params.value);
                if (isNaN(numericValue)) {
                    return formattedValue;
                }
                if (field.templateData.forceDecimals && typeof field.templateData.maxDecimalsCount === 'number') {
                    formattedValue = numericValue.toFixed(field.templateData.maxDecimalsCount);
                    numericValue = parseFloat(formattedValue);
                } else {
                    formattedValue = numericValue;
                }
                if (field.templateData.thousandSeparator) {
                    formattedValue = new Intl.NumberFormat('es-AR', {
                        minimumFractionDigits: field.templateData.forceDecimals && typeof field.templateData.maxDecimalsCount === 'number' ? field.templateData.maxDecimalsCount : 0,
                        maximumFractionDigits: field.templateData.forceDecimals && typeof field.templateData.maxDecimalsCount === 'number' ? field.templateData.maxDecimalsCount : 20
                    }).format(numericValue);
                }
            }
            return formattedValue;
        },
        formulaGraphGetter: function (params) {
            if (params.data.hasOwnProperty(params.colDef.field) && params.data[params.colDef.field] === undefined) {
                //  || params.data[params.colDef.field].value === undefined
                return '';
            }

            let rawValue = params.data[params.colDef.field];
            let formattedValue = rawValue;
            const field = params.colDef.formData;

            if (field && field.templateData && !field.templateData.isAdvanced) {
                let numericValue = parseFloat(rawValue);
                if (isNaN(numericValue)) {
                    return formattedValue;
                }
                if (field.templateData.forceDecimals && typeof field.templateData.formula?.decimals === 'number') {
                    formattedValue = numericValue.toFixed(field.templateData.formula.decimals);
                    numericValue = parseFloat(formattedValue);
                } else {
                    formattedValue = numericValue;
                }
                if (field.templateData.thousandSeparator) {
                    formattedValue = new Intl.NumberFormat('en-US', {
                        minimumFractionDigits: field.templateData.forceDecimals && typeof field.templateData.formula?.decimals === 'number' ? field.templateData.formula.decimals : 0,
                        maximumFractionDigits: field.templateData.forceDecimals && typeof field.templateData.formula?.decimals === 'number' ? field.templateData.formula.decimals : 20
                    }).format(numericValue);
                }
            }
            return formattedValue?.toString();
        },
        timestampGetter: function (params) {
            try {
                if (params.data.payload[params.colDef.field] != undefined && params.data.payload[params.colDef.field].value != undefined) {
                    return new Date(params.data.payload[params.colDef.field].value);
                }
            } catch (e) {
                console.log(e);
            }
            return;
        },
        timestampGetter2: function (params) {
            try {
                if (params.data[params.colDef.field]) {
                    return new Date(params.data[params.colDef.field]);
                }
            } catch (e) {
                console.log(e);
            }
            return;
        },
        dateGetter: function (params) {
            try {
                if (params.data.payload[params.colDef.field] && params.data.payload[params.colDef.field].value) {
                    return new Date(params.data.payload[params.colDef.field].value);
                }
            }
            catch (e) {
                console.log(e)
            }
            return;
        },
        timeGetter: function (params) {
            try {
                if (params.data.payload[params.colDef.field] && params.data.payload[params.colDef.field].value) {
                    return new Date(params.data.payload[params.colDef.field].value);
                }
            }
            catch (e) {
                console.log(e)
            }
            return;
        },
        multipleGetter: function (params) {
            //Fix para cuando esta dentro de una lista simple
            // Quita prefijos tipo "*|", "OTHER|" o "3|" dejando la etiqueta visible (incluye emojis).
            let fieldId = params.colDef.field.replace("payload.", '').replace(".value", '');
            if (params.data.payload[fieldId] == undefined || params.data.payload[fieldId].value == undefined) {
                return;
            }
            const stripOptionLabel = function (raw) {
                if (raw == null || raw === '') {
                    return '';
                }
                const s = String(raw);
                const idx = s.indexOf("|");
                return idx >= 0 ? s.substring(idx + 1) : s;
            };
            const value = params.data.payload[fieldId].value;
            if (Array.isArray(value)) {
                return value.map(stripOptionLabel).join(',');
            }
            return stripOptionLabel(value);
        },
        startedAtGetter: function (params) {
            if (!params.data._startedAt) {
                return;
            }
            return new Date(params.data._startedAt);
        },
        createdAtGetter: function (params) {
            if (!params.data._createdAt) {
                return;
            }
            return new Date(params.data._createdAt);
        },
        closedAtGetter: function (params) {
            if (!params.data.closedAt) {
                return;
            }
            return new Date(params.data.closedAt);
        },
        demoraGetter: function (params) {
            if (!params.data._startedAt) {
                return;
            }
            let d1 = new Date(params.data._createdAt);
            let d2 = new Date(params.data._startedAt);
            let dif = parseFloat((d1 - d2) / 1000 / 60 / 60).toFixed(2);
            if (dif < 0)
                dif = 0;
            return dif;
        },
        dateComparator: function dateComparator(date1, date2) {
            if (date1 === undefined && date2 === undefined) {
                return 0;
            }
            if (date1 === undefined) {
                return -1;
            }
            if (date2 === undefined) {
                return 1;
            }

            if (date1.length === 10) date1 = date1.concat('T00:00');
            if (date2.length === 10) date2 = date2.concat('T00:00');
            var date1Obj = new Date(date1);
            var date2Obj = new Date(date2);
            var date1Number = date1Obj.getTime();
            var date2Number = date2Obj.getTime();

            // var date1Number = date1.getTime();
            // var date2Number = date2.getTime();

            if (date1Number === null && date2Number === null) {
                return 0;
            }
            if (date1Number === null) {
                return -1;
            }
            if (date2Number === null) {
                return 1;
            }

            return date1Number - date2Number;
        },
        timeFilter: TimeFilter,
        dateFilter: DateFilter,
        localeText: {
            page: translate.instant('AGGRID.PAGE'),
            more: translate.instant('AGGRID.MORE'),
            to: translate.instant('AGGRID.TO'),
            of: translate.instant('AGGRID.OF'),
            next: translate.instant('AGGRID.NEXT'),
            last: translate.instant('AGGRID.LAST'),
            first: translate.instant('AGGRID.FIRST'),
            previous: translate.instant('AGGRID.PREVIOUS'),
            loadingOoo: translate.instant('AGGRID.LOADING'),
            // for set filter
            selectAll: translate.instant('AGGRID.SELECTALL'),
            searchOoo: translate.instant('AGGRID.SEARCH'),
            blanks: translate.instant('AGGRID.BLANKS'),
            // for number filter
            equals: translate.instant('AGGRID.EQUAL'),
            lessThan: translate.instant('AGGRID.LESSTHAN'),
            greaterThan: translate.instant('AGGRID.GREATERTHAN'),
            applyFilter: translate.instant('AGGRID.APPLYFILTER'),
            filterOoo: translate.instant('AGGRID.FILTER'),
            // for text filter
            contains: translate.instant('AGGRID.CONTAINS'),
            startsWith: translate.instant('AGGRID.STARTWITH'),
            endsWith: translate.instant('AGGRID.ENDWITH'),
            // the header of the default group column
            group: translate.instant('AGGRID.GROUP'),
            // tool panel
            columns: translate.instant('AGGRID.COLUMNS'),
            rowGroupColumns: translate.instant('AGGRID.GROUPCOLUMNS'),
            rowGroupColumnsEmptyMessage: translate.instant('AGGRID.GROUPCOLS_EMPTY'),
            valueColumns: translate.instant('AGGRID.VALUECOLUMNS'),
            valueColumnsEmptyMessage: translate.instant('AGGRID.VALUECOLS_EMPTY'),
        },
        bindShiftWheelHorizontalScroll: bindShiftWheelHorizontalScroll,
        bindPinnedRightScrollbarSync: bindPinnedRightScrollbarSync
    };
};
